import { icons } from "./icons"

export const offers = [
  {
    name : "Killan James",
    price: 16.605
  },
  {
    name : "Harry James",
    price: 22.408
  }
]
